<template>
    <div class="text-center">


    </div>
    <transition name="modal" v-if="urlImage">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container text-center">
                        <slot name="body" class="text-center">
                            <img :src="urlImage" @click="urlImage=null" class="img-thumbnail">
                        </slot>
                </div>
            </div>
        </div>
    </transition>

    <div class="row margin10Solu">
        <div class="col-1" >
        </div>
        <div class="col-10" >
            <div class="row">
                <div class="col-2" >
                    <br />
                    Filtre :
                </div>
                <div class="col-2">
                    Début
                    <input type="date" class="form-control" v-model="dateEntree" @change="majDateSortie()"/>
                </div>
                <div class="col-2">
                    Fin
                    <input type="date" class="form-control"  v-model="dateSortie" @change="majDateEntree()"/>
                </div>
                <div class="col-2">
                    Sortie
                    <select class="form-control"  v-model="selectSortie">
                        <option value="0"></option>
                        <option value="1">Oui</option>
                        <option value="2">Non</option>
                    </select>
                </div>
                <div class="col-2">
                    Recherche
                    <input type="text" title="Le mot sera recherché dans le prénom, le nom et l'entreprise" class="form-control" v-model="textRecherc" v-on:keyup.enter="afficheRegistre()">
                </div>
                <div class="col-2">
                    <br />
                    <button @click="afficheRegistre()" class="btn btn-primary">Valider</button>
                </div>
            </div>
            <br />
            <div class="row">
                <div class="col-12">
                    <div class="alert alert-warning" role="alert" v-if="!listVisiteur || !listVisiteur.length">
                        Aucun visiteur enregistré pendant cette période
                    </div>
                    <table class="table table-striped table-hover table-bordered" v-else>
                        <tr>
                            <th class="thtab">Nom</th>
                            <th class="thtab">Prénom</th>
                            <th class="thtab">Entreprise</th>
                            <th class="thtab">Heure entrée</th>
                            <th class="thtab">Signature entrée</th>
                            <th class="thtab">Heure sortie</th>
                            <th class="thtab">Signature sortie</th>
                        </tr>
                        <tr v-for="(visiteurs) in listVisiteur" :key="visiteurs.id">
                            <td>{{formatText(visiteurs.nom)}}</td>
                            <td>{{formatText(visiteurs.prenom)}}</td>
                            <td>{{formatText(visiteurs.entreprise)}}</td>
                            <td>{{visiteurs.dateEntree}}</td>
                            <td><img :src="visiteurs.signatureEntree" width="200" @click="zoomImage(visiteurs.signatureEntree)"></td>
                            <td>{{visiteurs.dateSortie}}</td>
                            <td> <span v-if="visiteurs.signatureSortie!=null">
                                    <img  :src="visiteurs.signatureSortie" width="200" @click="zoomImage(visiteurs.signatureSortie)">
                                </span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Registre-Visiteur",
        props: [ 'site', 'racine','token'],
        data: function() {
            return {
                dateEntree:new Date().toISOString().slice(0,10),
                dateSortie:new Date().toISOString().slice(0,10),
                selectSortie:null,valide:true,errors:null, msg:null,listVisiteur:[],
                textRecherc:null,urlImage:null
            };
        },
        methods: {
            tokenValide(json) {
                if (json['status'] == '401') {
                    this.$emit('token')
                }
            },
            formatText(text)
            {
                return decodeURIComponent(escape(text))
            },
            zoomImage(url)
            {
                console.log(url)
                this.urlImage = url
            },
            afficheRegistre()
            {
                var myHeaders = new Headers();
                myHeaders.append("Authorization", "Bearer "+this.token);

                var formdata = new FormData();
                formdata.append('selectSortie', this.selectSortie);
                formdata.append('dateEntree', this.dateEntree);
                formdata.append('dateSortie', this.dateSortie);
                formdata.append('textRecherc', this.textRecherc);

                var requestOptions = {
                    method: 'POST',
                    headers: myHeaders,
                    body: formdata,
                    redirect: 'follow'
                };

                fetch(this.racine + this.site + "api/getVisiteursByCritere", requestOptions)
                    .then(response => response.json())
                    .then(json => {
                        console.log(json);
                        console.log(json['id']);
                        this.tokenValide(json)

                        if (json['valide'] == 1) {
                            this.msg = "Votre inscription s'est bien déroulé.";
                            this.listVisiteur = json['listVisiteur']

                        }
                        else {
                            this.errors = "Une erreur est survenue pendant l'enregistrement.";
                        }
                    })

            },
            majDateSortie()
            {
                if(this.dateEntree>this.dateSortie)
                {
                    this.dateSortie = this.dateEntree
                }
            },
            majDateEntree()
            {
                if(this.dateSortie<this.dateEntree)
                {
                    this.dateEntree = this.dateSortie
                }
            }

        },
        created() {
            var d = new Date()
            //d.setDate(d.getDate() - 7);
            this.dateEntree = d.getFullYear() + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" +("0" + d.getDate()).slice(-2);
            //this.dateSortie = d.getFullYear() + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" +("0" + d.getDate()).slice(-2);
            this.afficheRegistre()
        }
    }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 940px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

</style>